import { inject } from '@angular/core';
import { ActivatedRoute, type Data, type Params } from '@angular/router';
import { distinctUntilChanged, map, type Observable } from 'rxjs';
import { RouterParamType, routerParamTypeMapping } from '../constants/params-name-map.constant';

/**
 * **Must be run in DI context or provide {@link activatedRoute}.**
 *
 * @returns An observable for the routing parameter.
 */
export const observeParam = <T = string>(
  type: RouterParamType,
  key: string,
  activatedRoute = inject(ActivatedRoute),
) =>
  (activatedRoute[routerParamTypeMapping[type]] as Observable<Data | Params>).pipe(
    map((v) => v[key] as T),
    distinctUntilChanged(),
  );
